import React, { useEffect, useState } from 'react'
import axios from 'axios'

import { useNavigate } from 'react-router-dom'






function Create() {
     
  const [owner,setOwner]=useState('')
  const [worker,setWorker]=useState('')
  const [vehicle,setVehicle]=useState('')
  const [vmodel,setVmodel]=useState('')
  const [labourCahrge,setLabourCharge]=useState(0)
  const [payment,setPayment]=useState(0)
  const [Workin,setWorking]=useState('')
  const [shope,setShope]=useState('')

  const [userId,setUserId]=useState('')

   console.log(userId)

   useEffect(()=>{
    setUserId(localStorage.getItem('useuserId'))
   },[])

  const navigate=useNavigate()
  
      const handleAPI= async(e)=>{

          e.preventDefault()
          
         await axios.post('https://tinkus.onrender.com/createData',{
            Shope_Name:shope,
            Owener_Name: owner,
            Worker_Name: worker,
            Vehical_Name: vehicle,
            Vehical_Model: vmodel,
            Working_in_Vehicle:Workin,
            Labour_Charge: labourCahrge,
            Payment: payment,
            userId:userId
           })
           .then((result)=>{
            console.log(result)
            alert("Create SuccessFully")
            navigate('/')
           })
          .catch((err)=>{
            console.log(err)
    
            alert(err.response.data.msg)
          })


      }




    return (
        <div>
            <form  className='container  mt-2 ' id='bor'>

            <h1  id='t' style={{ textAlign: "center",  }} ><i>Use Memo</i></h1>
              
                



                {/* <h1 style={{ textAlign: "center" }} >Create Your Data</h1>
                <div className="row">
                    <div className="col md-6">
                    <label for="exampleInputEmail1" class="form-label">Email address</label>
                    <div class="form-check">
                            
                            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                            <label class="form-check-label" for="flexRadioDefault1">
                                Default radio
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" checked />
                            <label class="form-check-label" for="flexRadioDefault2">
                                Default checked radio
                            </label>
                        </div>
                       

                    </div>
                    <div className="col md-6">

                        
                        <div class="dropdown">
                            <button class="btn btn-secondary dropdown-toggle m-2" type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false">
                                Dropdown button
                            </button>
                            <ul class="dropdown-menu dropdown-menu-dark" aria-labelledby="dropdownMenuButton2">
                                <li><a class="dropdown-item active" >Action</a></li>
                                <li><a class="dropdown-item" href="#">Another action</a></li>
                                <li><a class="dropdown-item" href="#">Something else here</a></li>
                                <li><hr class="dropdown-divider" /></li>
                                <li><a class="dropdown-item" href="#">Separated link</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
 */}




               <div class="mb-2">
                    <label for="exampleInputEmail1" class="form-label">Shope Name</label>
                    <input onChange={(e)=>setShope(e.target.value)} type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />

                </div>

                <div class="mb-2">
                    <label for="exampleInputEmail1" class="form-label">Owener Name</label>
                    <input onChange={(e)=>setOwner(e.target.value)} type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />

                </div>
                <div class="mb-2">
                    <label  for="exampleInputPassword1" class="form-label">Worker Name</label>
                    <input onChange={(e)=>setWorker(e.target.value)} type="text" class="form-control" id="exampleInputPassword1" />
                </div>


                <div class="mb-2">
                    <label for="exampleInputEmail1" class="form-label">Vehicale Name</label>
                    <input onChange={(e)=>setVehicle(e.target.value)} type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />

                </div>
                <div class="mb-2">
                    <label for="exampleInputPassword1" class="form-label">Vehicles Model</label>
                    <input onChange={(e)=>setVmodel(e.target.value)} type="text" class="form-control" id="exampleInputPassword1" />
                </div>

                <div class="mb-2">
                    <label for="exampleInputEmail1" class="form-label">Working In Vehicles</label>
                    <textarea onChange={(e)=>setWorking(e.target.value)} type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />

                </div>
                <div class="mb-2">
                    <label for="exampleInputPassword1" class="form-label">Labour Charge</label>
                    <input onChange={(e)=>setLabourCharge(e.target.value)} type="text" class="form-control" id="exampleInputPassword1" />
                </div>

                <div class="mb-3">
                    <label for="exampleInputPassword1" class="form-label">Payment</label>
                    <input onChange={(e)=>setPayment(e.target.value)} type="text" class="form-control" id="exampleInputPassword1" />
                </div>

                <button onClick={handleAPI} type="submit" class="btn btn-primary mb-2">Submit</button>
            </form>

        </div>
    )
}

export default Create
